export default __webpack_public_path__ + "static/carousel5-67004a8f82c4b5a70bee7bdb759e8bd6.webp";